import { WebInterfaceBaseState } from '../../../../../../../common/base/state';
import { isNullOrUndefined } from '@bimser/core';
import { createSelector } from 'reselect';
import { ObjectSelectPanelContent } from '../entities/IObjectSelectPanelContent';

const panelData = (state: WebInterfaceBaseState) => {
	const panelData: ObjectSelectPanelContent = state.modules.dm.objectSelect;
	if (isNullOrUndefined(panelData)) {
		return false;
	} else {
		return panelData.loading;
	}
};

const getPopoverLoading = createSelector([panelData], (loading: boolean) => loading);

export { getPopoverLoading };
